(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-teams-ids.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-teams-ids.js');
"use strict";

const useTeams = svs.components.marketplaceCompetition.services.hooks.useTeams;
const _React = React,
  useMemo = _React.useMemo;
const useTeamsIds = competitionId => {
  const _useTeams = useTeams(competitionId),
    teams = _useTeams.teams;
  const memoizedTeams = useMemo(() => {
    if (!teams) {
      return undefined;
    }
    const teamsIds = Object.keys(teams);
    teamsIds.forEach(teamId => parseInt(teamId, 10));
    return teamsIds.map(teamId => parseInt(teamId, 10));
  }, [teams]);
  return memoizedTeams;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useTeamsIds', useTeamsIds);

 })(window);